import React, { useState } from 'react';

export default function Section({ id, title, count, defaultOpen = true, headerRight, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section
      id={id}
      className="rounded-lg border mt-6"
      style={{ background: '#fff', borderColor: '#ECEBE5', scrollMarginTop: 80 }}
    >
      <header
        onClick={() => setOpen(!open)}
        className="flex items-center justify-between px-5 py-3.5 cursor-pointer select-none"
      >
        <div className="flex items-center gap-2.5">
          <span style={{
            display: 'inline-block', width: 10, transition: 'transform 120ms',
            transform: open ? 'rotate(90deg)' : 'rotate(0deg)', color: '#9A9A95'
          }}>›</span>
          <h2 className="text-[14px] font-semibold tracking-tight" style={{ color: '#1A1A1A' }}>{title}</h2>
          {count && <span className="text-[11px]" style={{ color: '#9A9A95' }}>{count}</span>}
        </div>
        {headerRight && <div onClick={(e) => e.stopPropagation()}>{headerRight}</div>}
      </header>
      {open && <div className="px-5 pb-5">{children}</div>}
    </section>
  );
}
